import axios from "axios";
import React, { useEffect, useState } from "react";
import { AUDIT_CALLING_REPORT } from "../../constants";
import dayjs from "dayjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import {
  Box,
  Card,
  Divider,
  Grid,
  MenuItem,
  Skeleton,
  TextField,
} from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Importing ChartDataLabels plugin
import { useNavigate } from "react-router-dom";

// Registering Chart.js components to enable functionality
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels // Registering the data labels plugin
);

// Functional Component for displaying Pie Chart
function OutgoingCallDistributionComponent({
  connectedCalls,
  notConnectedCalls,
  totalOutCall,
  filters,
  isLoading,
}) {
  const navigate = useNavigate();

  // Handle case when data is still loading
  if (isLoading || !connectedCalls) {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Card sx={{ p: 2 }}>
            {/* Title Shimmer */}
            <Skeleton
              variant="text"
              width={200}
              height={30}
              sx={{ mb: 2 }}
            />{" "}
            {/* Title shimmer */}
            <Divider sx={{ marginBottom: "16px" }} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
              }}
            >
              <Skeleton variant="circular" width={300} height={300} />{" "}
              {/* Shimmer for the chart */}
              <Skeleton
                variant="text"
                width={150}
                height={30}
                sx={{ mt: 2 }}
              />{" "}
              {/* Shimmer for text */}
            </Box>
          </Card>
        </Grid>
      </Grid>
    );
  }

  // Destructuring data for the Pie Chart from props
  const totalCalls = totalOutCall; // Total number of calls
  const conectedCalls = connectedCalls.totalCount; // Number of connected calls
  const missedCalls = notConnectedCalls.totalCount; // Number of missed calls

  // Data structure for the Pie Chart
  const pieChartData = {
    labels: ["Connected Calls", "Not Connected Calls"], // Labels for the pie slices
    datasets: [
      {
        data: [conectedCalls, missedCalls], // Data values for each slice
        backgroundColor: ["#008000", "#87CEEB"], // Pastel colors: Light Green and Light Blue
      },
    ],
  };

  // Data labels configuration
  const options = {
    plugins: {
      datalabels: {
        color: "#000", // Set data labels text color
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => value, // Display the value on the chart
        anchor: "center", // Center the label inside the slice
        align: "center", // Center the label inside the slice
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedIndex = elements[0].index; // Get the index of the clicked slice
        const clickedLabel = pieChartData.labels[clickedIndex]; // Get the label of the clicked slice
        // Navigate based on the clicked slice
        navigate(`/outgoing_calling_report`, {
          state: { prevFilters: filters },
        });
      }
    },
  };

  return (
    <Grid container spacing={4}>
      {" "}
      {/* Main container with spacing */}
      {/* Section for displaying the Pie Chart */}
      <Grid item xs={12}>
        {" "}
        {/* Full width for the grid item */}
        <Card sx={{ p: 2 }}>
          {" "}
          {/* Card for styling and layout */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "16px",
              }}
            >
              Outgoing Call Distribution {/* Title for the chart section */}
            </h4>
          </Box>
          <Divider sx={{ marginBottom: "16px" }} />{" "}
          {/* Divider for visual separation */}
          <Box
            sx={{
              height: "400px", // Height of the chart container
              display: "flex", // Flexbox layout
              justifyContent: "center", // Centering the chart horizontally
              marginTop: "20px", // Spacing above the chart
            }}
          >
            <Doughnut data={pieChartData} options={options} />{" "}
            {/* Rendering the Doughnut chart with options */}
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}

export default OutgoingCallDistributionComponent; // Exporting the component for use in other files
